import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { checkAuth as apiCheckAuth } from '../../services/api';
import { STORAGE_KEYS } from '../../constants';

export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      await apiCheckAuth(username, password);
      localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, btoa(`${username}:${password}`));
      return { username };
    } catch (error) {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        return rejectWithValue('Invalid credentials');
      }
      return rejectWithValue(error.response?.data?.message || error.message || 'Login failed');
    }
  },
);

const initialState = {
  user: null,
  token: localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) || null,
  status: 'idle',
  error: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
      state.user = null;
      state.token = null;
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload.username;
        state.token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
